export const ROUTE_SIGN_UP = '/sign-up/:inviteCode?';
export const ROUTE_EARLY_ACCESS = '/early-access/:inviteCode?';
export const ROUTE_SIGN_IN = '/sign-in';
export const ROUTE_AUTH_MAGIC = '/auth/magic';
export const ROUTE_SIGN_IN_ENTER_EMAIL = `${ROUTE_SIGN_IN}/enter-email`;
export const ROUTE_SIGN_IN_VERIFY_OTP = `${ROUTE_SIGN_IN}/verify-otp`;
export const ROUTE_PAYMENT = '/payment';
export const ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD = `${ROUTE_PAYMENT}/collect-payment-method/:inviteCode?`;
export const ROUTE_PAYMENT_VERIFY_PAYMENT = `${ROUTE_PAYMENT}/verify-payment`;
export const ROUTE_ACCOUNT = '/account';
export const ROUTE_ACCOUNT_EDIT_PERSONAL_INFO = `${ROUTE_ACCOUNT}/edit-personal-info`;
export const ROUTE_ACCOUNT_EDIT_MEMBERSHIP = `${ROUTE_ACCOUNT}/edit-membership`;
export const ROUTE_QUESTIONNAIRE = '/questionnaire';
export const ROUTE_PPRA = '/free-assessment';
export const ROUTE_PPRA_QUESTIONNAIRE = '/free-assessment/questionnaire';
export const ROUTE_PPRA_PAYMENT = '/free-assessment/payment';
export const ROUTE_PAYMENT_PAGE_V2 = '/join';
export const ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD_V2 = `${ROUTE_PPRA_PAYMENT}/collect-payment-method/:inviteCode?`;
export const ROUTE_PAYMENT_VERIFY_PAYMENT_V2 = `${ROUTE_PPRA_PAYMENT}/verify-payment`;
export const ROUTE_PPRA_RESULTS = '/free-assessment/results/:surveySessionId';
export const ROUTE_PPRA_RESULTS_PDP = '/free-assessment/pdp/:inviteCode?';
export const ROUTE_PPRA_RESULTS_LOADING = '/free-assessment/results-loading/:surveySessionId';
export const ROUTE_PPRA_MEMBERSHIP_INTERSTITIAL = '/free-assessment/membership';
export const ROUTE_ACTION_PLAN = '/action-plan/:idIntervention?';
export const ROUTE_BUILD_ACTION_PLAN = '/action-plan/build';
export const ROUTE_TESTING_PLAN = '/testing-plan';
export const ROUTE_TESTING_PLAN_COMPLETE = `${ROUTE_TESTING_PLAN}/complete-test/:idTestOption`;
export const ROUTE_TEST_DETAILS = `${ROUTE_TESTING_PLAN}/test/:idTest`;
export const ROUTE_HEALTH_DATA = `/health-data`;
export const ROUTE_DASHBOARD = '/';
export const ROUTE_RISK_TREND = '/risk-trend';
export const ROUTE_RISK_ANALYSIS = '/risk-analysis';
export const ROUTE_SINGLE_CANCER_VIEW = '/cancer/:cancerId';
export const ROUTE_ACCOUNT_EDIT_COMMUNICATION_PREFERENCES = `${ROUTE_ACCOUNT}/edit-communication-preferences`;
export const ROUTE_LOADING_SCREEN = '/loading-screen/:firstAssessment/:url?';
export const ROUTE_QUIZLET = '/quiz';
export const ROUTE_QUIZLET_QUESTIONNAIRE = `${ROUTE_QUIZLET}/questionnaire`;
export const ROUTE_QUIZLET_RESULTS = `${ROUTE_QUIZLET}/value`;

// Versioned quizlet routes
export const ROUTE_QUIZLET_VERSIONED = '/quizlet';
export const ROUTE_QUIZLET_V1 = '/quizlet/v1';
export const ROUTE_QUIZLET_V2 = '/quizlet/v2';
export const ROUTE_QUIZLET_V2_QUESTIONNAIRE = '/quizlet/v2/questionnaire';
export const ROUTE_QUIZLET_V2_QUESTION = '/quizlet/v2/questionnaire/:questionSlug';
export const ROUTE_QUIZLET_V2_RESULTS = '/quizlet/v2/results';

export const ROUTE_QUESTIONNAIRE_V2 = '/risk-assessment';
export const ROUTE_QUESTIONNAIRE_V2_QUESTION = '/risk-assessment/:questionSlug';
export const ROUTE_RISK_SCORE_REVEAL = '/risk-score-reveal';
export const ROUTE_WEARABLES = '/wearables';
export const ROUTE_LABS = '/labs';
export const ROUTE_LABS_ALL = '/labs/all';
export const ROUTE_LABS_ORDER = '/labs/order';
export const ROUTE_LABS_ORDER_STEP_1 = '/labs/order/step-1';
export const ROUTE_LABS_ORDER_STEP_2 = '/labs/order/step-2';
export const ROUTE_LABS_ORDER_STEP_3 = '/labs/order/step-3';
export const ROUTE_LABS_ORDER_STEP_4 = '/labs/order/step-4';
export const ROUTE_LABS_ORDER_STEP_5 = '/labs/order/step-5';
export const ROUTE_BIOMARKER_DETAIL = '/labs/biomarkers/:slug';
export const ROUTE_CONSENT = '/consent/:slug';
